import React, { useState, useRef } from 'react';
// Import the Training Request Form link from TechiesBaseAcademy.js
import { TRAINING_REQUEST_FORM_LINK } from './TechiesBaseAcademy';

const courses = [
  {
    icon: '☁️',
    title: 'Cloud & DevOps Engineering',
    description: 'Master cloud platforms and DevOps practices. Learn to design, deploy, and manage scalable, automated infrastructure.',
    features: [
      'AWS, Azure & GCP Fundamentals',
      'Infrastructure as Code (Terraform, CloudFormation)',
      'CI/CD Pipelines',
      'Docker & Kubernetes',
      'Monitoring & Logging',
      'Security Best Practices',
      'Cost Optimization',
      'Real-world DevOps Projects'
    ],
    interviewQAUrl: '/devops-interview-qa'
  },
  {
    icon: '🖥️',
    title: 'Java Fullstack Development',
    description: 'Become a versatile fullstack developer. Master Java backend, modern frontend (Angular/ReactJS), and AWS Cloud deployment.',
    features: [
      'Core Java & OOP',
      'Spring Boot & REST APIs',
      'Frontend with Angular or ReactJS',
      'Responsive UI/UX Design',
      'Database Integration (MySQL/PostgreSQL)',
      'Authentication & Security',
      'AWS Cloud Deployment',
      'CI/CD & DevOps Basics',
      'Real-world Fullstack Projects'
    ]
  },
  {
    icon: '☕',
    title: 'Java Backend Development',
    description: 'Become a professional Java backend developer. Learn to build robust, scalable server-side applications using Java and Spring Boot.',
    features: [
      'Core Java & OOP',
      'Spring Boot & REST APIs',
      'Database Integration (MySQL/PostgreSQL)',
      'Authentication & Security',
      'Microservices Architecture',
      'Unit & Integration Testing',
      'Deployment & DevOps Basics'
    ]
  },
  {
    icon: '💻',
    title: 'Python Fullstack Development',
    description: 'Become a versatile fullstack developer. Master Python backend, modern frontend (ReactJS/Angular), and AWS Cloud deployment.',
    features: [
      'Core Python & OOP',
      'Django & REST APIs',
      'Frontend with ReactJS or Angular',
      'Responsive UI/UX Design',
      'Database Integration (MySQL/PostgreSQL)',
      'Authentication & Security',
      'AWS Cloud Deployment',
      'CI/CD & DevOps Basics',
      'Real-world Fullstack Projects'
    ]
  },
  {
    icon: '🐍',
    title: 'Python Backend Development',
    description: 'Become a professional Python backend developer. Learn to build robust, scalable server-side applications using Python and Django.',
    features: [
      'Core Python & OOP',
      'Django & REST APIs',
      'Database Integration (MySQL/PostgreSQL)',
      'Authentication & Security',
      'Microservices Architecture',
      'Unit & Integration Testing',
      'Deployment & DevOps Basics'
    ]
  },
  {
    icon: '☁️',
    title: 'AWS Cloud Architecture',
    description: 'Become an AWS certified professional. Learn to design, deploy, and manage scalable cloud infrastructure.',
    features: ['AWS Core Services', 'Architecture Patterns', 'DevOps & CI/CD', 'Security Best Practices', 'Certification Prep']
  },
  {
    icon: '🔐',
    title: 'Cybersecurity Specialist',
    description: 'Protect digital assets with comprehensive cybersecurity training. Learn ethical hacking and security protocols.',
    features: ['Network Security', 'Ethical Hacking', 'Incident Response', 'Security Auditing', 'Compliance Standards']
  },
  
  
];


const Courses = () => {
  const [showDialog, setShowDialog] = useState(false);
  const timerRef = useRef(null);

  const handleEnrollClick = () => {
    setShowDialog(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setShowDialog(false), 30000);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  return (
    <section id="courses" className="courses">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Popular Training Programs</h2>
          <p className="section-subtitle">Choose from our comprehensive range of industry-relevant courses designed to accelerate your career growth</p>
        </div>
        <div className="course-grid">
          {courses.map((course, index) => (
            <div key={index} className="course-card">
              <div className="course-icon">{course.icon}</div>
              <h3 className="course-title">{course.title}</h3>
              <p className="course-desc">{course.description}</p>
              <ul className="course-features">
                {course.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              {course.interviewQAUrl && (
                <div className="interview-qa-link">
                  <a 
                    href={`${window.location.origin}${course.interviewQAUrl}`} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="qa-link"
                  >
                    📚 DevOps Interview Q&A
                  </a>
                </div>
              )}
              <br />
              <div className="course-footer">
                <button className="course-button" onClick={handleEnrollClick}>Enroll Now</button>
              </div>
            </div>
          ))}
        </div>
        {showDialog && (
          <div className="enroll-dialog-overlay" onClick={handleCloseDialog}>
            <div className="enroll-dialog" onClick={e => e.stopPropagation()}>
              <button className="enroll-dialog-close" onClick={handleCloseDialog}>&times;</button>
              <h3>Training Request</h3>
              <p>
                Please complete the <a href={TRAINING_REQUEST_FORM_LINK} target="_blank" rel="noopener noreferrer">Training Request Form</a> to enroll.
              </p>
              <p style={{fontSize: '0.9em', color: '#888'}}>This dialog will close automatically after 30 seconds.</p>
            </div>
            <style>{`
              .enroll-dialog-overlay {
                position: fixed;
                top: 0; left: 0; right: 0; bottom: 0;
                background: rgba(0,0,0,0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 1000;
              }
              .enroll-dialog {
                background: #fff;
                padding: 2rem 2.5rem;
                border-radius: 10px;
                box-shadow: 0 4px 24px rgba(0,0,0,0.18);
                max-width: 90vw;
                min-width: 300px;
                position: relative;
                text-align: center;
              }
              .enroll-dialog-close {
                position: absolute;
                top: 0.5rem;
                right: 0.7rem;
                background: none;
                border: none;
                font-size: 2rem;
                color: #888;
                cursor: pointer;
              }
              .enroll-dialog a {
                color: #1976d2;
                text-decoration: underline;
                font-weight: 500;
              }
              .interview-qa-link {
                margin: 1rem 0;
                text-align: center;
              }
              .qa-link {
                @apply inline-block bg-gradient-to-r from-purple-500 to-blue-600 text-white no-underline py-2 px-4 rounded-md font-medium text-sm transition-all duration-200 shadow-md;
              }
              .qa-link:hover {
                @apply transform -translate-y-0.5 shadow-lg text-white no-underline;
              }
            `}</style>
          </div>
        )}
      </div>
    </section>
  );
};

export default Courses;
